<template>
  <div
    class="percentage-wrap d-flex flex-column position-absolute"
    :class="[align === 'right' ? 'align-items-end' : align === 'center' ? 'align-items-center' : '']"
    :style="{ fontSize: size }"
  >
    <div class="percent d-flex">
      <span class="percent-num" v-html="numRounded"></span>
      <span class="percent-sign">%</span>
    </div>
    <span
      class="percent-label fade-label adobe-clean-black text-uppercase"
      v-if="!hideLabel"
      v-html="label"
      :style="[ { opacity: labelAlpha }, labelPos === 'top' ? { order: -1 } : {}, scaleLabel ? { fontSize: Math.min(16, fontSize / 4) + 'px' } : {} ]"
      @transitionend="handleFade"
    ></span>
  </div>
</template>

<script>
  import { industryTypes } from '@/lib/consts'
  import StateMixin from '@/components/report/mixins/StateMixin'

  export default {
    name: 'Percentage',
    mixins: [ StateMixin ],
    props: {
      num: { type: Number, required: true },
      label: String,
      indOverride: String,
      fontSize: Number,
      hideLabel: { type: Boolean, default () { return false } },
      scaleLabel: { type: Boolean, default () { return false } },
      labelPos: { type: String, default () { return 'bottom' } },
      align: { type: String, default () { return 'left' } }
    },
    data () {
      return {
        rising: true,
        indWords: [],
        labelAlpha: 1
      }
    },
    computed: {
      size () {
        return this.isSmall ? this.fontSize + 'px' : '125px'
      },
      numRounded () {
        return this.rising ? Math.ceil( this.num ) : Math.floor( this.num )
      }
    },
    watch: {
      num ( newVal, old ) {
        this.rising = (newVal > old)
      },
      industry () {
        if ( this.indWords.length > 0 ) {
          this.labelAlpha = 0
        }
      }
    },
    methods: {
      handleFade ( { target: { style: { opacity } } } ) {
        if ( opacity === '0' ) {
          this.setIndWords()
          this.$nextTick( () => {
            this.labelAlpha = 1
          } )
        }
      },
      setIndWords () {
        [].forEach.call( this.indWords, el => {
          el.innerHTML = industryTypes[ this.industry ].membersName
        } )
      },
      getIndWords () {
        this.indWords = this.$el.getElementsByClassName( 'industry-word' )
      }
    },
    mounted () {
      this.getIndWords()
      if ( this.indWords.length > 0 ) this.setIndWords()
    }
  }
</script>

<style lang="scss">
  @import "../../../assets/scss/global/the_goods";

  .percentage-wrap {
    color : #fff;

    .percent {
      margin-top    : -0.05em;
      margin-bottom : 0.175em;

      &-num {
        letter-spacing : 0.005em;
        line-height    : 0.9;
        margin-bottom  : -0.175em;
        font-family    : $knockout-50;
      }

      &-sign {
        font-size   : 0.375em;
        font-family : $knockout-30;
      }

      &-label {
        font-size      : rem(18);
        letter-spacing : 0.111em;
        padding-left   : 0.2em;
        padding-bottom : 0.2em;

        @include screen-md-lg-xl {
          font-size : rem(20);
        }
      }

    }

    .fade-label {
      transition : opacity #{$data-trans-time / 6};
    }

    &.align-items-end {
      .percent-label {
        padding-left  : 0;
        padding-right : 0.2em;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/content/Percentage.vue